import(/* webpackMode: "eager" */ "/home/u902218437/domains/allaboutcampus.com/hbuilds/source/eduportal/src/app/compare-colleges/page.tsx");
